export enum ServiceTypeEnum {
  CLOUD = 'cloud',
  CONNECTION = 'connection',
  MOBILE_ODIDO = 'mobile',
  MOBILE_KPN = 'mobile_kpn',
  SIP_TRUNK = 'sip_trunk',
}
